import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { shortTestimonials } from '../data/testimonials';
export function TestimonialsStrip() {
  return <section className="py-12 bg-mist border-y border-mist-dark" data-id="element-259" data-mp="3sq1vbv6hrw06">
      <div className="max-w-7xl mx-auto px-4" data-id="element-260" data-mp="3ssem8xu89gpd">
        <div className="text-center mb-7" data-id="element-261" data-mp="3nz21wzwkzw2f">
          <p className="text-navy font-bold tracking-widest uppercase text-sm" data-id="element-262" data-mp="3nyafofovjaot">
            ⭐ What Wrestling Coaches Are Looking For
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-263" data-mp="nao2zglba7k">
          {shortTestimonials.map((testimonial, index) => <motion.article key={testimonial.text} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white border border-mist-dark p-6 rounded-2xl relative shadow-sm flex flex-col" data-id="element-264" data-mp="figx7vazfp54" data-mpi={index}>
              <div className="flex gap-1 text-gold mb-4" aria-label="5 out of 5 stars" data-id="element-265" data-mp="cead1if98mbo">
                {[...Array(5)].map((_, starIndex) => <Star key={starIndex} size={16} fill="currentColor" data-id="element-266" data-mp="ldno2fj11iyi" data-mpi={starIndex} />)}
              </div>
              <p className="text-slate italic mb-6 text-sm leading-relaxed" data-id="element-267" data-mp="q4nk7ikbnwzy">
                “{testimonial.text}”
              </p>
              <div className="flex items-center gap-3 mt-auto" data-id="element-268" data-mp="v2fbcad57f33">
                <div className="w-10 h-10 rounded-full bg-azure-light border border-azure flex items-center justify-center text-azure-dark font-bold text-xs shrink-0" data-id="element-269" data-mp="101s7xmttg0iv">
                  {testimonial.initials}
                </div>
                <div data-id="element-270" data-mp="191osbc96ad84">
                  <div className="font-bold text-navy text-sm" data-id="element-271" data-mp="1926sul2vbdlu">{testimonial.name}</div>
                  <div className="text-xs text-azure" data-id="element-272" data-mp="35wt8pxb1zfkc">{testimonial.role}</div>
                </div>
              </div>
            </motion.article>)}
        </div>
        <p className="text-center text-[11px] text-slate mt-6" data-id="element-273" data-mp="hz31doa0g8c8">
          Replace testimonial-style copy with verified customer feedback before publishing.
        </p>
      </div>
    </section>;
}